import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Mockup3D } from './Mockup3D';
const bonuses = [{
  title: 'Reprogramá tu Mente Ansiosa',
  description: 'Rompé los patrones de pensamiento que alimentan tu ansiedad.',
  color: 'navy' as const,
  image: 'https://cdn.magicpatterns.com/uploads/wWcYRxtmUCsSrdWx8YtTTF/dada_las_imagens_de_referencia__necesito_que_redise_es_aquel_6.png'
}, {
  title: 'Dormí en Paz',
  description: 'Protocolo nocturno para desactivar la mente antes de dormir.',
  color: 'slate' as const,
  image: 'https://cdn.magicpatterns.com/uploads/6MHKX7sKNWWY9odZeuS2RS/dada_las_imagens_de_referencia__necesito_que_redise_es_aquel_5.png'
}, {
  title: 'Ansiedad en Relaciones y Apego',
  description: 'Dejá de depender emocionalmente y sentí seguridad interna.',
  color: 'beige' as const,
  image: 'https://cdn.magicpatterns.com/uploads/kKMDgQuaV7CPF3UxuFiCea/dada_las_imagens_de_referencia__necesito_que_redise_es_aquel_4.png'
}, {
  title: 'Calmá tu Cuerpo',
  description: 'Técnicas somáticas para liberar tensión física acumulada.',
  color: 'gold' as const,
  image: 'https://cdn.magicpatterns.com/uploads/8nrrNwyAMi5zCseANfRYS7/dada_las_imagens_de_referencia__necesito_que_redise_es_aquel_3.png'
}, {
  title: 'Detox de Estrés y Sobrecarga Mental',
  description: 'Limpiá tu mente del ruido, las redes y la sobreinformación.',
  color: 'slate' as const,
  image: 'https://cdn.magicpatterns.com/uploads/5aAH2CVbyqZnxcupwWj71d/dada_las_imagens_de_referencia__necesito_que_redise_es_aquel_2.png'
}, {
  title: 'Sistema de Paz en 21 Días',
  description: 'El plan día por día para instalar calma como hábito.',
  color: 'navy' as const,
  image: 'https://cdn.magicpatterns.com/uploads/ix3PAMEEsLgBarYJBJyJHK/dada_las_imagens_de_referencia__necesito_que_redise_es_aquel.png'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BonusSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-white" data-id="element-27">
      <div className="max-w-6xl mx-auto px-6" data-id="element-28">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-30">
            Además, recibís 6 bonos premium
          </h2>
          <p className="text-slate max-w-2xl mx-auto mb-6" data-id="element-31">
            Cada bono fue diseñado para atacar un ángulo específico de tu
            ansiedad.
          </p>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-32"></div>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-33">
          {bonuses.map((bonus, index) => <motion.div key={index} variants={itemVariants} className="bg-beige-light rounded-3xl p-8 flex flex-col items-center text-center border border-beige-dark/30 hover:shadow-md transition-shadow duration-300" data-id="element-34">
              <div className="w-full max-w-[160px] aspect-[3/4] mb-8 overflow-hidden rounded-xl" data-id="element-35">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-36" /> : <Mockup3D title={bonus.title} subtitle={`BONO ${index + 1}`} variant="bonus" color={bonus.color} data-id="element-37" />}
              </div>

              <div className="inline-block px-3 py-1 bg-gold/10 text-gold-dark text-[10px] font-bold tracking-wider uppercase rounded-full mb-4" data-id="element-38">
                Bono Premium
              </div>

              <h3 className="text-xl font-serif text-navy mb-3 leading-snug" data-id="element-39">
                {bonus.title}
              </h3>

              <p className="text-sm text-slate leading-relaxed" data-id="element-40">
                {bonus.description}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div className="mt-16 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} data-id="element-41">
          <button onClick={scrollToCheckout} className="px-8 py-4 bg-navy text-beige-light rounded-xl font-medium text-lg shadow-premium hover:shadow-premium-hover hover:-translate-y-1 transition-all duration-300 border border-gold/20" data-id="element-42">
            QUIERO TODO ESTO AHORA
          </button>
        </motion.div>
      </div>
    </section>;
}